import { Router } from '@angular/router';
import * as _ from 'lodash';

export const DATETIME_FORMAT = 'YYYY/MM/DD HH:mm:ss';
export const UTC_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_FORMAT = 'YYYY/MM/DD';
export const TIME_FORMAT = 'HH:mm:ss';
export const KILO_BYTE = 1024;

export function getTime(durationSec: number) {
    const h = Math.floor(durationSec / 3600);
    const m = Math.floor((durationSec % 3600) / 60);
    const s = Math.floor((durationSec % 3600) % 60);

    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}

export function navigateTo(router: Router, url: string, queryParams: { state_env: string }): void {
    const routerUrl = router.serializeUrl(router.createUrlTree([url], { queryParams }));
    window.open(routerUrl, '_blank');
}

export function bytesToKiloBytes(bytes: number): number {
    if (!_.isNumber(bytes)) {
        return 0;
    }
    return _.round(bytes / KILO_BYTE, 2);
}

export function millisecondsToSeconds(milliseconds: number): number {
    if (!_.isNumber(milliseconds)) {
        return 0;
    }
    return _.round(milliseconds / 1000, 2);
}

export function getPercent(value: number, total: number) {
    if (!_.isNumber(value) || !_.isNumber(total)) {
        return 0;
    }
    return _.round((value * 100) / (total || 1), 2);
}
